import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { WHEEL_ITEM_LIST } from 'src/constants/queryKeys';

export const networkGetWheelItemInfo = async (wheelItemId) => {
  const res = await axiosInstance.post(`WheelItem/Info/${wheelItemId}`);
  return res;
};

export const networkGetWheelItemList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`WheelItem/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export const useFetchWheelItemsList = (payload, pageIndex, pageSize) => {
  return useQuery({
    queryKey: [WHEEL_ITEM_LIST, payload, pageIndex, pageSize],
    queryFn: () => networkGetWheelItemList(payload, pageIndex, pageSize),
  });
};

export const networkGetWheelItemTypeList = async (pageIndex, pageSize) => {
  const res = await axiosInstance.post(`WheelItemType/List/${pageIndex}/${pageSize}`);
  return res;
};

export const useFetchWheelItemTypeList = (pageIndex = 0, pageSize = 50) => {
  return useQuery({
    queryKey: ['wheel-item-type-list', pageIndex, pageSize],
    queryFn: () => networkGetWheelItemTypeList(pageIndex, pageSize),
  });
};

export const networkCreateWheelItem = async (data) => {
  const res = await axiosInstance.post('WheelItem/Insert', data);
  return res;
};

export const networkUpdateWheelItem = async (wheelItemId, data) => {
  const res = await axiosInstance.post(`WheelItem/Update/${wheelItemId}`, data);
  return res;
};

export const networkRemoveWheelItem = async (wheelItemId) => {
  const res = await axiosInstance.post(`WheelItem/Remove/${wheelItemId}`);
  return res;
};
